






import { Component, Prop, Vue } from 'vue-property-decorator'
import { RoleId } from '@/enum'
import CardImage from './CardImage.vue'

@Component({
  components: {
    CardImage
  }
})
export default class Card extends Vue {
  @Prop() roleId!: RoleId;
}
